import React, { Component } from 'react'
import logo from './assets/img/logo.svg'
import icon_tw2 from './assets/img/icon_tw2.png'
import icon_fb2 from './assets/img/icon_fb2.png'

class Footer extends Component {

  render() {
    return (
    <div className="footer">
    <a href="mailto:contact@hacksummit.org">Contact us</a>
    <span className="div">&nbsp;&nbsp;|&nbsp;&nbsp; </span><a href="https://www.crowdcast.io/hack_summit" target="_blank">Past years</a>
    <span className="div">&nbsp;&nbsp;|&nbsp;&nbsp; </span><a href="https://www.iubenda.com/privacy-policy/94178599" target="_blank">Privacy Policy</a>
    <span className="div">&nbsp;&nbsp;|&nbsp;&nbsp; </span><a href="https://www.iubenda.com/privacy-policy/94178599/cookie-policy" target="_blank">Cookie Policy</a>
    
    
    {/* <span className="div">&nbsp;&nbsp;|&nbsp;&nbsp; </span><a href="#" target="_blank">FAQ</a> */}
    <span className="div">&nbsp;&nbsp;|&nbsp;&nbsp;</span><a href="https://twitter.com/hack_summit" rel="nofollow" target="_blank" className="social">&nbsp;
    <img src={icon_tw2} alt="Twitter" weight="15" height="15"/></a><a href="https://www.facebook.com/hack.summit" rel="nofollow" target="_blank">&nbsp;&nbsp;
    <img src={icon_fb2} alt="Facebook" weight="15" height="15"/></a>
    </div>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.js